import type { LessonRecurringStore } from './interfaces'

import { LessonRecurringFinishType } from '../../enums'

export const createLessonRecurringState = (): LessonRecurringStore => ({
  loading: false,
  slots: null,
  modal: null,
  today: '',
  startDate: '',
  days: [],
  selectedDay: 'Mon',
  finishType: LessonRecurringFinishType.Occurrences,
  occurrences: 1,
  lessons: 1,
  finishDate: '',
  filters: null,
  tutors: [],
  tutorsLoading: false,
  tutorId: null,
  submitting: false,
})
